const FROM = document.title.includes("Mur") ? "public" : "ami";
/* Page du pote (ou du public) : envoie au relais en ligne, l'appli du porteur l'interroge toutes les 0,8 s.
   POST https://app.skale.be/clignote/relais.php?s=<salle> {"type":"texte"|"anim","valeur":"...","de":"prénom"} ; 1 envoi par seconde.
   Corps JSON envoyé en text/plain : requête « simple », sans pré-vol OPTIONS (testé : le relais lit le JSON quand même). */
const RELAIS = "https://app.skale.be/clignote/relais.php";
const salle = (new URLSearchParams(location.search).get("s") || "").toLowerCase();
const salleOk = /^[a-z0-9]{6,16}$/.test(salle);
const $ = id => document.getElementById(id);
const t = $("t"), de = $("de"), msg = $("msg"), go = $("go");
const WORDS = FROM === "ami" ? ["lol", "ivre?", "06?", "♥♥♥", "bouh", "taxi", "wow"] : ["bravo", "♥♥♥", "wow", "sante", "yeah!", "bis!"];
const ANIMS_AMI = FROM === "ami" ? [["coeurs", "Cœurs"], ["clin", "Clin d'œil"], ["feu", "Feu d'artifice"], ["xx", "KO"], ["larmes", "Larmes"], ["dollarYeux", "Yeux dollars"]] : [];
let choix = { type: "texte", valeur: "" };
try { de.value = localStorage.getItem("clignote-prenom") || ""; } catch (e) {}
de.oninput = () => { try { localStorage.setItem("clignote-prenom", de.value); } catch (e) {} };
$("mots").innerHTML = WORDS.map(w => `<button class="puce mot">${w}</button>`).join("");
$("anims").innerHTML = ANIMS_AMI.map(([id, n]) => `<button class="puce" data-a="${id}">${n}</button>`).join("");
if (!ANIMS_AMI.length) $("lblAnims").style.display = "none";
const marquer = b => document.querySelectorAll(".puce").forEach(x => x.classList.toggle("on", x === b));
document.querySelectorAll("#mots .puce").forEach(b => b.onclick = () => { t.value = b.textContent; choix = { type: "texte", valeur: t.value }; marquer(b); upd(); });
document.querySelectorAll("#anims .puce").forEach(b => b.onclick = () => { choix = { type: "anim", valeur: b.dataset.a }; marquer(b); t.value = ""; upd(); });
t.oninput = () => { t.value = t.value.toLowerCase(); choix = { type: "texte", valeur: t.value }; marquer(null); upd(); };
function upd() {
  const f = $("fit");
  if (choix.type === "anim") { f.textContent = "Animation : " + ((ANIMS[choix.valeur] || {}).n || ""); f.className = "fit"; return; }
  const w = textWidth(t.value || " "); f.textContent = w > COLS ? "Trop long : ça va défiler" : "Tient sur l'écran (" + w + "/24)"; f.className = "fit" + (w > COLS ? " trop" : "");
}
upd();
const t0 = performance.now();
(function loop(n) {
  const st = choix.type === "anim" ? { mode: "anim", id: choix.valeur } : { mode: "text", text: t.value || " ", effect: fits(t.value || " ") ? "fixe" : "defiler" };
  drawMatrix($("pv"), frame(st, n - t0), { frame: true }); requestAnimationFrame(loop);
})(0);
if (!salleOk) { $("err").style.display = "block"; go.disabled = true; }
const dire = (txt, cls) => { msg.textContent = txt; msg.className = cls || ""; };
let attente = false;
async function envoyer() {
  const valeur = choix.type === "anim" ? choix.valeur : t.value.trim();
  if (!valeur) { dire("Écris un mot ou choisis une idée.", "ko"); return; }
  if (!salleOk || attente) return;
  attente = true; go.disabled = true; dire("Envoi…");
  try {
    const r = await fetch(RELAIS + "?s=" + salle, { method: "POST", mode: "cors", headers: { "Content-Type": "text/plain;charset=UTF-8" }, body: JSON.stringify({ type: choix.type, valeur, de: de.value.trim().slice(0, 20) }) });
    if (r.status === 429) dire("Doucement : un envoi par seconde. Réessaie dans un instant.", "ko");
    else if (!r.ok) dire("Le relais a refusé l'envoi (erreur " + r.status + ") : rescanne le QR, puis réessaie.", "ko");
    else { dire(FROM === "ami" ? "Envoyé : ça s'affiche sur ses lunettes dès qu'il accepte." : "Envoyé : ton mot s'affiche dès qu'il est validé.", "ok"); t.value = ""; choix = { type: "texte", valeur: "" }; marquer(null); upd(); }
  } catch (e) { dire("Pas de réseau : vérifie ta connexion, puis réessaie.", "ko"); }
  finally { setTimeout(() => { attente = false; go.disabled = !salleOk; }, 1000); }
}
go.onclick = envoyer;
t.onkeydown = e => { if (e.key === "Enter") envoyer(); };
